//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';
import tabbox from '@/components/ui/tabbox';
import loadmore from '@/components/ui/loadmore';

import goodsList from '@/components/goodsList';
// import mainMenuTab from "@/components/mainMenuTab";

export default {
    components: {goodsList,cardbox,navbar,tabbox,loadmore},
    data(){
        return {
            orderInfo: {
                goods:[],
                store: {},
                extm: {},
            },
            orderId: 0,
        }
    },
    filters: {
        orderState: function(value){
            switch(value){
                case 0:
                    return '交易关闭';
                case 11:
                    return '已下单';
                case 20:
                    return '正在配货';
                case 40:
                    return '已完成';

            }
        },

        timer: function(value){
            if(!value) return '';
            let date = new Date(value*1000);
            return common.formatDate(date);
        }
    },
    methods:{

        // 重新购买
        addCart(itemList){

            let specid = [],quantity=[];

            itemList.forEach(val=>{
                if(val.spec_id>0 && val.quantity>0){
                    specid.push(val.spec_id);
                    quantity.push(val.quantity);
                }
            })

            const opts = {
                url: api.cartAdd,
                data: {
                    spec_id: specid.join(),
                    quantity: quantity.join()
                }
            }

            common.query(opts).then(res=>{
                this.$router.push("/cart");
            },res=>{
                this.$vux.toast.text(res.message);
            })

        },

        // 取消订单
        cancelOrder(item){

            const _this = this;

            const opts = {
                url: api.myOrderCancel,
                data: {
                    id: item.order_id
                },
                type: 'put'
            }

            this.$vux.confirm.show({
                title: '订单操作',
                content: '确认是否取消订单?',
                onConfirm () {
                    common.query(opts).then(res=>{
                        _this.$vux.toast.text("操作成功。",'top');
                        _this.initTab(3);
                    },res=>{
                        _this.$vux.toast.text(res.message);
                    })
                }
            })

        },


        // 查询订单
        queryMyOrder(){

            const opts = {
                url: api.myOrderDetail,
                data: {
                    order_id: this.orderId
                },
                type: 'get'
            }
            common.query(opts).then(res=>{

                this.orderInfo = res.data;

            },res=>{
                this.$vux.toast.text(res.message);
            });
        },

    },
    mounted(){

        if(!this.$route.query.orderId){
            this.$vux.toast.text("访问订单页不存在！",'top');
            this.$router.push('/member/order');
        }
        this.orderId = this.$route.query.orderId;
        this.queryMyOrder();
    },
}




// WEBPACK FOOTER //
// ./src/views/member/orderDetail.vue